import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { EditorBookingItem } from '../editor-booking-item/editor-booking-item.model';
import { EditorBookingItemTreeDataEditStore } from './editor-booking-item-tree-data-edit.store';
import { EditorDialogStore } from '../editor-dialog/editor-dialog.store';
import { SecurityService } from '@fry/lib/security';
import { DialogComponent } from '@fry/components/common/dialog';


@Component({
    selector: 'eas-editor-booking-item-tree-data-edit',
    templateUrl: './editor-booking-item-tree-data-edit.component.html',
    styleUrls: ['./editor-booking-item-tree-data-edit.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemTreeDataEditComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();
  rootItem: EditorBookingItem;
  patchingItemTreeForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<EditorBookingItemTreeDataEditComponent>,
    private itemTreeDataEditStore: EditorBookingItemTreeDataEditStore,
    private itemDialogStore: EditorDialogStore,
    private security: SecurityService,
    private dialog: MatDialog,
  ) {

  }

  ngOnInit() {
    this.itemTreeDataEditStore.replacingItemTree$
      .pipe(
        takeUntil(this.destroyed$),
        filter(replacingItemTree => replacingItemTree !== null)
      )
      .subscribe(replacingItemTree => this.rootItem = replacingItemTree.itemList[0]);

    this.itemTreeDataEditStore.patchingItemTreeForm$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(patchingItemTreeForm => this.patchingItemTreeForm = patchingItemTreeForm);
  }

  ngOnDestroy() {
    this.itemTreeDataEditStore.stopEditing();
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onSubmit() {
    if (this.getPatchingItemTreeFormControl('extraRoles')) {
      this.security.hasPermission('bookingItems.edit', {roles: this.getPatchingItemTreeFormControl('extraRoles').value}).subscribe((hasPermission: boolean) => {
      if (!hasPermission) {
        // If permission is granted, show the dialog
        this.dialog.open(DialogComponent, {
          data: {
            title: $localize`Restricted access`,
            content: $localize`This booking item has been configured with restricted access roles. Please choose a role which allows you to edit this booking item.`,
            okButton: $localize`Save`,
            cancelButton: $localize`Cancel`
          },
          disableClose: true
        }).afterClosed().subscribe(result => {
          if (result === true) {
            this.saveAndClose();
          }
        });
      } else {
        this.saveAndClose();
      }
    });
    } else {
      this.saveAndClose();
    }
  }

  private saveAndClose() {
    this.itemTreeDataEditStore.save();
    this.itemDialogStore.stopEditing();
    this.dialogRef.close();
  }

  onCancel() {
    this.itemDialogStore.stopEditing();
    this.dialogRef.close();
  }

  getPatchingItemTreeFormControl(key: string): FormControl {
    return this.patchingItemTreeForm.get(key) as FormControl;
  }
}
